function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.644.212a.3.3 0 00-.424 0L.212 1.22a.3.3 0 000 .424l3.144 3.144a.3.3 0 010 .424L.212 8.356a.3.3 0 000 .425L1.22 9.788a.3.3 0 00.425 0l3.144-3.144a.3.3 0 01.424 0l3.144 3.144a.3.3 0 00.424 0L9.788 8.78a.3.3 0 000-.424L6.644 5.212a.3.3 0 010-.424l3.144-3.144a.3.3 0 000-.425L8.78.212a.3.3 0 00-.425 0L5.212 3.356a.3.3 0 01-.424 0L1.644.212z"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgClose;